export default __webpack_public_path__ + "69d597ed3f54716dcb6481b0bae98447.gif";